import { FC } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { SendProjectButton } from '../../_competition/components/SendProjectButton';
import styled from 'styled-components';
import {LayoutConst} from "../../core";
import { useTranslation } from 'react-i18next';

const Title = styled(FInter.SectionTitleFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

const Description = styled(FInter.TextFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 17px;
    line-height: 22px;
    margin-top: 16px;
    max-width: 815px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 285px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }
`;

export const CompetitionBravoErrorModal: FC<{competitionEndDate: string, onClick: () => void, }> = ({competitionEndDate, onClick}) => {
    const {  i18n: { language } } = useTranslation();

    const deadLineDate=  new Date(competitionEndDate)
    .toLocaleString(language, { 
      day: 'numeric', 
      month: 'long', 
      hour: '2-digit', 
      minute: '2-digit' 
    })
    .replace(',', ' в');
       

    return <div>
        <FlexBox justify={'center'} direction='column' directionMobile='column'>
       
            <Title>
                <span>К сожалению, вы не можете<br/>  подать работу на проверку</span>
            </Title>
            <Description>
            Приём проектов завершился {deadLineDate}
            </Description>
            <FlexBox justify={'center'} offsetTop={40}>
                <SendProjectButton width={283} onClick={onClick}>
                   На страницу модуля
                </SendProjectButton>
            </FlexBox>
        </FlexBox>
    </div>

};
import { FC } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { SendProjectButton } from '../../_competition/components/SendProjectButton';
import styled from 'styled-components';
import {LayoutConst} from "../../core";
import { useTranslation } from 'react-i18next';

const Title = styled(FInter.SectionTitleFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

const Description = styled(FInter.TextFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 17px;
    line-height: 22px;
    margin-top: 16px;
    max-width: 815px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 285px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }
`;

export const CompetitionBravoErrorModal: FC<{competitionEndDate: string, onClick: () => void, }> = ({competitionEndDate, onClick}) => {
    const {  i18n: { language } } = useTranslation();

    const deadLineDate=  new Date(competitionEndDate)
    .toLocaleString(language, { 
      day: 'numeric', 
      month: 'long', 
      hour: '2-digit', 
      minute: '2-digit' 
    })
    .replace(',', ' в');
       

    return <div>
        <FlexBox justify={'center'} direction='column' directionMobile='column'>
       
            <Title>
                <span>К сожалению, вы не можете<br/>  подать работу на проверку</span>
            </Title>
            <Description>
            Приём проектов завершился {deadLineDate}
            </Description>
            <FlexBox justify={'center'} offsetTop={40}>
                <SendProjectButton width={283} onClick={onClick}>
                   На страницу модуля
                </SendProjectButton>
            </FlexBox>
        </FlexBox>
    </div>

};
